<template>
  <div class="h-full bg-slate-100 dark:bg-zinc-800">
    <a
      href="#main-content"
      class="sr-only fixed left-4 top-4 z-[100] rounded-md bg-white px-4 py-2 text-slate-900 shadow-lg
        focus:not-sr-only"
    >
      Skip to main content
    </a>
    <dashboard-sidebar />
    <div class="relative min-h-full bg-slate-100 dark:bg-zinc-800 md:ml-64">
      <app-navbar />
      <div class="relative bg-primary pb-32 pt-6 md:pt-16" />
      <main
        id="main-content"
        tabindex="-1"
        class="-m-24 mx-auto size-full px-4 md:px-10"
      >
        <router-view />
        <footer-app />
      </main>
    </div>
    <global-search-input v-model:open="searchOpen" />
  </div>
</template>
<script setup lang="ts">
import AppNavbar from '../components/Navbars/AppNavbar.vue';
import DashboardSidebar from '../components/Sidebar/DashboardSidebar.vue';
import FooterApp from '../components/Footers/FooterApp.vue';
import GlobalSearchInput from '../components/Inputs/GlobalSearchInput.vue';
import { useStore } from '../api/index.ts';
import { ref, onMounted } from 'vue';
import { useKeyboardShortcut } from '../assets/js/helpers/KeyboardShortcutHandler.ts';

const store = useStore();
const searchOpen = ref(false);

if (store.checkedDomain && store.checkedDomain.data && store.checkedDomain.data.favicon) {
  let link = document.querySelector<HTMLLinkElement>('link[rel~=\'icon\']');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = import.meta.env.VITE_CDN_URL + store.checkedDomain.data.favicon;
}

onMounted(() => {
  // Cmd+K / Ctrl+K - toggle search (works even in inputs)
  useKeyboardShortcut('k', () => {
    searchOpen.value = !searchOpen.value;
  }, { allowInInputs: true, modifiers: ['meta', 'ctrl'] });

  // Escape - close search
  useKeyboardShortcut('Escape', () => {
    searchOpen.value = false;
  });
});
</script>
